import * as angular from "angular";
import {VehicleType} from "../../commons/types/vehicle.type";
import {PlanProjectEntity} from "../models/plan-project-entity.model";
import {RouteSwapResourceRequestModel} from "../models/route-swap-resource-request.model";
import {AddressQualityEnum} from "../../addresses/types/address-quality.enum";
import {SplitService} from "../../commons/services/split-service.service";
import {SchedulingSmsStatusEnum} from "../../oms/types/scheduling-sms-status.enum";
import {
  PlanningDraftEditRouteNameRequestModel
} from "../models/planning-draft-edit-route-name-request.model";
import {PlanningDraftEditRouteColorRequestModel} from "../models/planning-draft-edit-route-color-request.model";
import {PlanningDraftRouteFeedbackRequestModel} from "../models/planning-draft-route-feedback-request.model";

export class PlanningRequestsService {

  constructor(private PlanningAPI, private PlanningProjectsAPI, private $planningProjects,
              private PlanningDraftsAPI, private $planning, private $drafts, private splitService: SplitService) {
  }


  getProjects(from, to, branchIds) {
    const api = this.PlanningProjectsAPI.actions.getAll;
    return this.callProjects(api, {
      from: from,
      to: to,
      branchIds: branchIds
    }, {}, {});
  }


  getTemplates() {
    const api = this.PlanningAPI.actions.getAllTemplates;
    return this.call(api, {}, {}, {});
  }


  getTemplate(id) {
    const api = this.PlanningAPI.actions.getTemplate;
    return this.call(api, {}, {}, {id: id});
  }

  createTemplate(template) {
    const api = this.PlanningAPI.actions.createTemplate;
    return this.call(api, {}, template, {});
  }

  updateTemplate(template) {
    const api = this.PlanningAPI.actions.updateTemplate;
    return this.call(api, {}, template, {id: template.id});
  }

  deleteTemplate(templateId) {
    const api = this.PlanningAPI.actions.deleteTemplate;
    return this.call(api, {}, {}, {id: templateId});
  }

  getProject(id) {
    const api = this.PlanningProjectsAPI.actions.getOne;
    return this.callProjects(api, {}, {}, {id: id});
  }

  createProject(project: PlanProjectEntity) {
    const api = this.PlanningProjectsAPI.actions.create;
    return this.callProjects(api, {}, project, {});
  }

  createProjectWithOrders(project, ids, excludedIds, statuses, partiallyScheduled, from, to, branchIds, accountIds, serviceAreaIds,
                          tagNames, isNotTag, attempts, isPacked, filterByCreatedAt, displayStatus
    , schedulingRequired, obligateTimeWindow, noFromLocation, noToLocation, programTypes: string[], addressQualityGroup: AddressQualityEnum[], schedulingSmsStatuses?: SchedulingSmsStatusEnum[], pickupDepotIds?: string[], destinationDepotIds?: string[], depotIds?: string[], searchTerm?: string, noArea?: boolean) {
    const api = this.PlanningAPI.actions.createProjectWithOrders;
    return this.call(api, {
      ids: ids,
      excludedIds: excludedIds,
      status: statuses,
      partiallyScheduled: partiallyScheduled,
      from: from,
      to: to,
      branchIds: branchIds,
      accountIds: accountIds,
      serviceAreaIds: serviceAreaIds,
      noArea: noArea,
      tags: tagNames,
      noTags: isNotTag,
      attempts: attempts,
      packed: isPacked,
      filterByCreatedAt: filterByCreatedAt,
      displayStatus: displayStatus,
      schedulingRequired: schedulingRequired,
      obligateTimeWindow: obligateTimeWindow,
      noFromLocation: noFromLocation,
      noToLocation: noToLocation,
      pickupDepotIds: pickupDepotIds,
      destinationDepotIds: destinationDepotIds,
      depotIds: depotIds,
      programType: programTypes,
      addressQualityGroup: addressQualityGroup,
      deliverySchedulingStatus: schedulingSmsStatuses,
      searchTerm: searchTerm
    }, project, {});
  }

  createProjectWithFulfillments(payload) {
    const api = this.PlanningAPI.actions.createProjectWithFulfillments;
    return this.call(api, {}, payload, {});
  }

  deleteProject(projectId) {
    const api = this.PlanningProjectsAPI.actions.deleteOne;
    return this.callProjects(api, {}, {}, {id: projectId});
  }

  getProjectJobs(projectId) {
    const api = this.PlanningProjectsAPI.actions.getProjectJobs;
    return this.callProjects(api, {}, {}, {projectId: projectId});
  }

  getProjectResources(projectId) {
    const api = this.PlanningProjectsAPI.actions.getProjectResources;
    return this.callProjects(api, {}, {}, {projectId: projectId});
  }


  getProjectDepots(projectId) {
    const api = this.PlanningProjectsAPI.actions.getProjectDepots;
    return this.callProjects(api, {}, {}, {projectId: projectId});
  }

  addJobsToProject(jobs, projectId) {
    const api = this.PlanningProjectsAPI.actions.addJobsToProject;
    return this.callProjects(api, {}, jobs, {id: projectId});
  }

  updateJobInProject(job, projectId) {
    const api = this.PlanningProjectsAPI.actions.updateJobInProject;
    return this.callProjects(api, {}, job, {id: projectId, jobId: job.id});
  }

  deleteJobsFromProject(jobIds, projectId) {
    const api = this.PlanningProjectsAPI.actions.deleteJobsFromProject;
    return this.callProjects(api, {}, jobIds, {id: projectId});
  }

  addOrdersToProject(payload, projectId) {
    const api = this.PlanningAPI.actions.addOrdersToProject;
    return this.call(api, {}, payload, {projectId: projectId});
  }


  addServicesToProject(payload, projectId: string) {
    const api = this.PlanningAPI.actions.addServicesToProject;
    return this.call(api, payload, {}, {projectId: projectId});
  }

  addAbortedServicesToProject(payload, projectId: string) {
    const api = this.PlanningAPI.actions.addAbortedServicesToProject;
    return this.call(api, payload, {}, {projectId: projectId});
  }

  addStepsToProject(from, to, statuses, branchIds, accountIds, serviceAreaIds,
                    attempts, tagNames, schedulingRequired, projectId) {
    const api = this.PlanningAPI.actions.addStepsToProject;
    return this.call(api, {}, {
      from: from,
      to: to,
      statuses: statuses,
      branchIds: branchIds,
      accountIds: accountIds,
      serviceAreaIds: serviceAreaIds,
      attempts: attempts,
      tags: tagNames,
      schedulingRequired: schedulingRequired
    }, {projectId: projectId});
  }

  addFulfillmentsToProject(FulfillmentExtFilter, projectId) {
    const api = this.PlanningAPI.actions.addFulfillmentToProject;
    return this.call(api, {}, FulfillmentExtFilter, {projectId: projectId});
  }

  addStopsToRoute(routeId, jobIdsToAdd, order, doOptimization, projectId, draftId, allowSkillsMismatch?: boolean) {
    const payload = {
      id: routeId,
      add: jobIdsToAdd,
      order: order
    };
    const api = this.PlanningProjectsAPI.actions.addStopsToRoute;
    return this.callProjects(api, {optimize: doOptimization, allowSkillsMismatch: allowSkillsMismatch}, [payload], {id: projectId, draftId: draftId});
  }

  moveActivityInRoutes(payload, projectId, draftId, groupRoutes, allowSkillsMismatch?: boolean) {
    const api = this.PlanningProjectsAPI.actions.addStopsToRoute;
    return this.callProjects(api, {group: groupRoutes, allowSkillsMismatch: allowSkillsMismatch}, payload, {id: projectId, draftId: draftId});
  }

  addJobsToPlanningRoute(payload, projectId, draftId, groupRoutes) {
    const api = this.PlanningDraftsAPI.actions.addJobsToPlanningRoute;
    const requestBody: any = {
      jobIds: payload.jobIds,
      isGrouped: !!groupRoutes,
      optimize: !!payload.optimize
    };
    if (payload.pickupIndex !== undefined) {
      requestBody.pickupIndex = payload.pickupIndex;
    }
    if (payload.destinationIndex !== undefined) {
      requestBody.destinationIndex = payload.destinationIndex;
    }
    return this.callDrafts(api, {allowSkillsMismatch: payload.allowSkillsMismatch}, requestBody, {
      projectId: projectId,
      draftId: draftId,
      routeId: payload.routeId
    });
  }

  assignAgent(projectId, draftId, routeIds: string[], agentId: string) {
    const api = this.PlanningDraftsAPI.actions.assignAgent;
    return this.callDrafts(api, {ids: routeIds}, {agentId: agentId,}, {
      projectId: projectId,
      draftId: draftId
    });
  }

  getDraftRouteMockData(payload, projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.getDraftRouteMockData;
    return this.callProjects(api, {}, payload, {id: projectId, draftId: draftId});
  }

  recalcRoutesInDraft(projectId, draftId: string, routeIds: string[], ignoreSequence?: boolean, preserveJobs?: boolean) {
    const api = this.PlanningProjectsAPI.actions.recalcRoutesInDraft;
    return this.callProjects(api, {overrideIgnoreSequence: ignoreSequence, preserveJobs: preserveJobs, id: routeIds}, {}, {
      projectId: projectId,
      draftId: draftId,
    });
  }

  deleteRoutesInDraft(routeIds, projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.deleteRouteInDraft;
    return this.callProjects(api, {}, routeIds, {id: projectId, draftId: draftId});
  }

  updateRouteLockState(projectId: string, draftId: string, routeId: string, isBlockedByUser: boolean) {
    const api = this.PlanningProjectsAPI.actions.updateRouteLockState;
    const payload = {
      [routeId]: isBlockedByUser,
    };
    return this.callProjects(api, {}, payload, {id: projectId, draftId: draftId});
  }

  getDraftDispatchProgress(projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.getDraftDispatchProgress;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  updateProjectDetails(project, projectId) {
    const api = this.PlanningProjectsAPI.actions.updateProjectDetails;
    return this.callProjects(api, {}, project, {id: projectId});
  }

  updateProjectSettings(settings, projectId) {
    const api = this.PlanningProjectsAPI.actions.updateProjectSettings;
    return this.callProjects(api, {}, settings, {id: projectId});
  }

  exportDraftReport(projectId, draftId) {
    const api = this.PlanningAPI.actions.exportDraftReport;
    return this.call(api, {projectId: projectId, draftId: draftId}, {}, {});
  }

  createDraftInProject(settings, draftName: string, excludeJobIds, excludeResourceIds, projectId, isOptimizedDraft, draftTemplateId?: string, useDraftTemplateSettings?: boolean, layeredOptimizeDraft?: boolean, optimizationSteps?: any[]) {

    const payload: any = {
      name: draftName,
      settings: settings || {},
      excludedJobsIds: excludeJobIds,
      excludedResourcesIds: excludeResourceIds,
      draftTemplateId: draftTemplateId,
      useDraftTemplateSettings: useDraftTemplateSettings
    };

    if (optimizationSteps?.length) {
      payload.optimizationSteps = optimizationSteps;
    }

    const api = this.PlanningProjectsAPI.actions.createDraftInProject;

    // return  isOptimizedDraft?
    //   this.callProjects(api, {optimizeDraft:true}, payload, {id: projectId}):
    //   this.callProjects(api, {}, payload, {id: projectId});
    return this.callProjects(api, {optimizeDraft: isOptimizedDraft, layeredOptimizeDraft: layeredOptimizeDraft}, payload, {id: projectId});
  }

  selectDraftInProject(projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.selectDraftInProject;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  deleteDraftsFromProject(draftIds, projectId) {
    const api = this.PlanningProjectsAPI.actions.deleteDraftsFromProject;
    return this.callProjects(api, {}, draftIds, {id: projectId});
  }

  approveAndDispatchDraft(draftId, projectId, dispatchLeftovers, autoAssignRoutes, keepProjectOpen) {
    const api = this.PlanningProjectsAPI.actions.approveAndDispatchDraft;
    return this.callProjects(api, {}, {
      dispatchLeftovers: dispatchLeftovers,
      autoAssignRoutes: autoAssignRoutes,
      keepProjectOpen: keepProjectOpen
    }, {id: projectId, draftId: draftId});
  }

  approveAndDispatchRoutes(draftId, projectId, routeIds) {
    const api = this.PlanningProjectsAPI.actions.approveAndDispatchDraft;
    return this.callProjects(api, {}, {
      routeIds: routeIds,
      keepProjectOpen: true
    }, {id: projectId, draftId: draftId});
  }

  getVehicleResources(projectId: string, type?: VehicleType, label?: any, query?: string) {
    const api = this.PlanningAPI.actions.getVehicleResources;
    return this.call(api, {projectId: projectId, type: type, label: label, query: query}, {}, {});
  }

  getAllocationResources(from: number, to: number, projectId: string, branchIds: string[], agentSkills: string[], agentIds: string[],
                         agentTags: string[], vehicleTypeIds: string[], vehicleTypes: string[], filterOutWithoutAgent: boolean, filterOutNotAvailableVehicle: boolean, excludedAgentTags?: string,
                         excludeAllocationsBeforeFromDate?: boolean, resourceTags?: string[]) {
    const api = this.PlanningAPI.actions.getAllocationResources;
    return this.call(api, {
      from: from,
      to: to,
      projectId: projectId,
      skill: agentSkills,
      branchId: branchIds,
      agentId: agentIds,
      agentTag: agentTags,
      excludedAgentTag: excludedAgentTags,
      vehicleType: vehicleTypes,
      vehicleTypeId: vehicleTypeIds,
      filterOutWithoutAgent: filterOutWithoutAgent,
      filterOutNotAvailableVehicle: filterOutNotAvailableVehicle,
      excludeAllocationsBeforeFromDate: excludeAllocationsBeforeFromDate,
      resourceTag: resourceTags
    }, {}, {});
  }

  getAgentScheduleResources(from: number, to: number, branchIds: string[], agentTypes: string[], agentIds: string[], agentTags?: string[], agentSkills?: string[], excludedAgentTags?: string[]) {
    const api = this.PlanningAPI.actions.getAgentScheduleResources;
    return this.call(api, {
      from: from,
      to: to,
      branchId: branchIds,
      agentTypes: agentTypes,
      agentId: agentIds,
      agentTag: agentTags,
      excludedAgentTag: excludedAgentTags,
      agentSkill: agentSkills
    }, {}, {});
  }

  getDepots(projectId) {
    const api = this.PlanningAPI.actions.getDepots;
    return this.call(api, {projectId: projectId}, {}, {});
  }

  addResourcesToProject(resources, id, importAllocationResourcesServiceTemplate?: boolean) {
    const api = this.PlanningProjectsAPI.actions.addResourcesToProject;
    return this.callProjects(api, {importAllocationResourcesServiceTemplate: importAllocationResourcesServiceTemplate}, resources, {id: id});
  }

  addDepotsToProject(depots, id) {
    const api = this.PlanningProjectsAPI.actions.addDepotsToProject;
    return this.callProjects(api, {}, depots, {id: id});
  }

  deleteResourcesFromProject(resourceIds, projectId) {
    const api = this.PlanningProjectsAPI.actions.deleteResourcesFromProject;
    return this.callProjects(api, {}, resourceIds, {id: projectId});
  }

  deleteDepotsFromProject(depotIds, projectId) {
    const api = this.PlanningProjectsAPI.actions.deleteDepotsFromProject;
    return this.callProjects(api, {}, depotIds, {id: projectId});
  }

  updateDraft(draft, draftId, projectId) {
    const api = this.PlanningDraftsAPI.actions.updateDraft;
    return this.callDrafts(api, {}, draft, {projectId: projectId, draftId: draftId});
  }

  updateAddress(projectId: string, draftId: string,
                id: string, address: any, updateServices?: boolean, updateAccounts?: boolean) {
    const api = this.PlanningDraftsAPI.actions.updateAddress;

    return this.callDrafts(api, {
      updateServices: updateServices,
      updateAccounts: updateAccounts,
      exactAddressResolution: address.exactAddressResolution
    }, address, {projectId: projectId, draftId: draftId, id: id});
  }

  duplicateDraft(draftId, projectId) {
    const api = this.PlanningDraftsAPI.actions.duplicateDraft;
    return this.callDrafts(api, {}, {}, {projectId: projectId, draftId: draftId});
  }

  updateDraftSettings(settings, draftId, projectId) {
    const api = this.PlanningProjectsAPI.actions.updateDraftSettings;
    return this.callProjects(api, {}, settings, {id: projectId, draftId: draftId});
  }

  getDraftInProject(draftId, projectId) {
    const api = this.PlanningProjectsAPI.actions.getDraftInProject;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  getDraftsInProject(draftIds, projectId) {
    const api = this.PlanningProjectsAPI.actions.getDraftsInProject;
    return this.callProjects(api, {draftIds: draftIds}, {}, {id: projectId});
  }


  getDraftAnalysisInProject(draftId) {
    const api = this.PlanningAPI.actions.getDraftAnalysis;
    return this.call(api, {draftId: draftId}, {}, {});
  }

  optimizeDraft(draftId: string, projectId: string, layeredOptimizeDraft?: boolean) {
    const api = this.PlanningProjectsAPI.actions.optimizeDraft;
    return this.callProjects(api, {layeredOptimizeDraft: layeredOptimizeDraft}, {}, {id: projectId, draftId: draftId});
  }

  abortOptimizeDraft(draftId, projectId) {
    const api = this.PlanningProjectsAPI.actions.abortOptimizeDraft;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  getDraftRoutes(projectId, draftId, routeIds, groupRoutes) {
    // groupRoutes - FLAG for bundle items in route or not
    const api = this.PlanningDraftsAPI.actions.getDraftRoutes;
    return this.callDrafts(api, {expand: true, id: routeIds, group: groupRoutes}, {}, {
      projectId: projectId,
      draftId: draftId
    });
  }

  createRouteInDraft(resourceId, jobIds, draftId, projectId, groupRoutes, routeName?, stopIdOrder?, optimize?, allowSkillsMismatch?: boolean) {
    const api = this.PlanningProjectsAPI.actions.createRouteInDraft;
    return this.callProjects(api, {group: groupRoutes, optimize: optimize, allowSkillsMismatch: allowSkillsMismatch}, {
      jobIds: jobIds,
      resourceId: resourceId,
      routeName: routeName,
      stopIdOrder: stopIdOrder
    }, {
      id: projectId,
      draftId: draftId
    });
  }

  exportDraft(projectId, draftId, exportType, routeIds?, email?) {
    const api = this.PlanningAPI.actions.exportDraft;
    const emails: string[] = email ? [email] : undefined;
    return this.call(api, {
      projectId: projectId,
      draftId: draftId,
      data: exportType,
      routeId: routeIds,
      email: emails
    }, {}, {});
  }

  getDraftJobs(projectId, draftId, jobIds) {
    const api = this.PlanningDraftsAPI.actions.getDraftJobs;
    return this.callDrafts(api, {id: jobIds}, {}, {projectId: projectId, draftId: draftId});
  }

  getDraftResources(projectId, draftId, filterCanCreateRoute?: boolean) {
    const api = this.PlanningDraftsAPI.actions.getDraftResources;
    return this.callDrafts(api, {filterCanCreateRoute: filterCanCreateRoute}, {}, {projectId: projectId, draftId: draftId});
  }

  getDraftAccountsMetrics(projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.getDraftAccountsMetrics;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  getDraftSolutionMetrics(projectId, draftId) {
    const api = this.PlanningProjectsAPI.actions.getDraftSolutionMetrics;
    return this.callProjects(api, {}, {}, {id: projectId, draftId: draftId});
  }

  createDraftResources(projectId, draftId, payload) {
    const api = this.PlanningDraftsAPI.actions.createDraftResources;
    return this.callDrafts(api, {}, payload, {projectId: projectId, draftId: draftId});
  }

  updateDraftJobs(projectId, draftId, includeIds, excludeIds) {
    const api = this.PlanningDraftsAPI.actions.updateDraftJobs;
    return this.callDrafts(api, {}, {include: includeIds, exclude: excludeIds}, {
      projectId: projectId,
      draftId: draftId
    });
  }

  updateDraftResources(projectId, draftId, includeIds, excludeIds) {
    const api = this.PlanningDraftsAPI.actions.updateDraftResources;
    return this.callDrafts(api, {}, {include: includeIds, exclude: excludeIds}, {
      projectId: projectId,
      draftId: draftId
    });
  }

  updateResourceSequence(projectId, draftId, routeGroupId: string, orderedRouteIds: string[]) {
    const api = this.PlanningDraftsAPI.actions.updateResourceSequence;
    return this.callDrafts(api, {}, {orderedRouteIds: orderedRouteIds}, {
      projectId: projectId,
      draftId: draftId,
      routeGroupId: routeGroupId
    });
  }

  updateDraftResource(projectId, draftId, resourceId, payload) {
    const api = this.PlanningDraftsAPI.actions.updateDraftResource;
    return this.callDrafts(api, {}, payload, {
      projectId: projectId,
      draftId: draftId,
      resourceId: resourceId
    });
  }

  servicePlanning(serviceIds?: string[], routeIds?: string[], settings?, resources?, reOptimize?: boolean, takeResourcesFromRoute?: boolean) {
    const api = this.PlanningAPI.actions.servicePlanning;
    return this.call(api, {
      serviceIds: serviceIds,
      routeIds: routeIds,
      reOptimize: reOptimize,
      takeResourcesFromRoute: takeResourcesFromRoute
    }, {
      resources: resources,
      projectSettings: settings
    }, {});
  }

  getMonitoring(from: number, to: number, branchIds?: string[]) {
    const api = this.PlanningAPI.actions.getMonitoring;
    return this.call(api,
      {
        branchIds: branchIds,
        zoneId: this.splitService.getTimeZone(),
        from: from,
        to: to
      }, {}, {});
  }


  swapRouteResources(projectId: string, draftId: string, payload: RouteSwapResourceRequestModel[]) {
    const api = this.PlanningDraftsAPI.actions.swapRouteResources;
    return this.callDrafts(api, {}, payload, {
      projectId: projectId,
      draftId: draftId
    });
  }

  changeRouteResource(projectId: string, draftId: string, routeId: string, destinationResourceId: string) {
    const api = this.PlanningDraftsAPI.actions.changeRouteResource;
    return this.callDrafts(api, {}, {destinationResourceId: destinationResourceId}, {
      projectId: projectId,
      draftId: draftId,
      routeId: routeId
    });
  }

  updateRoutePickingTimeOffset(projectId: string, draftId: string, routeId: string, pickingTimeOffsetInMinutes: number) {
    const api = this.PlanningDraftsAPI.actions.updateRoutePickingTimeOffset;
    return this.callDrafts(api, {}, {pickingTimeOffsetInMinutes: pickingTimeOffsetInMinutes}, {
      projectId: projectId,
      draftId: draftId,
      routeId: routeId
    });
  }

  updateRoutesPickingTime(projectId: string, draftId: string, routeIds: string[], pickingTime: number) {
    const api = this.PlanningDraftsAPI.actions.updateRoutesPickingTime;
    return this.callDrafts(api, {}, {routeIds: routeIds, pickingTimestamp: pickingTime}, {
      projectId: projectId,
      draftId: draftId
    });
  }

  updateRouteName(projectId: string, draftId: string, routeId: string,
                  payload: PlanningDraftEditRouteNameRequestModel) {
    const api = this.PlanningDraftsAPI.actions.updateRouteName;
    return this.callDrafts(api, {}, payload, {
      projectId: projectId,
      draftId: draftId,
      routeId: routeId
    });
  }

  updateRouteColor(projectId: string, draftId: string, routeId: string,
                  payload: PlanningDraftEditRouteColorRequestModel) {
    const api = this.PlanningDraftsAPI.actions.updateRouteColor;
    return this.callDrafts(api, {}, payload, {
      projectId: projectId,
      draftId: draftId,
      routeId: routeId
    });
  }

  updateRouteFeedback(projectId: string, draftId: string, routeId: string,
                      payload: PlanningDraftRouteFeedbackRequestModel) {
    const api = this.PlanningDraftsAPI.actions.updateRouteFeedback;
    return this.callDrafts(api, {}, payload, {
      projectId: projectId,
      draftId: draftId,
      routeId: routeId
    });
  }

  toggleObligateTimeWindow(projectId: string, draftId: string, draftJobIds: string[], obligateTimeWindow: boolean) {
    const api = this.PlanningProjectsAPI.actions.toggleObligateTimeWindow;
    return this.callProjects(api, {ids: draftJobIds}, {
      obligateTimeWindow: obligateTimeWindow
    }, {
      projectId: projectId,
      draftId: draftId
    });
  }

  lockJobs(projectId: string, draftId: string, jobIdsByRouteId: Record<string, string[]>) {
    const api = this.PlanningProjectsAPI.actions.lockJobs;
    return this.callProjects(api, {}, {
      jobIdsByRouteId: jobIdsByRouteId
    }, {
      projectId: projectId,
      draftId: draftId
    });
  }

  unlockJobs(projectId: string, draftId: string, jobIds: string[]) {
    const api = this.PlanningProjectsAPI.actions.unlockJobs;
    return this.callProjects(api, {}, jobIds, {
      projectId: projectId,
      draftId: draftId
    });
  }

  importJobsIntoProject(projectId: string, filePreview) {
    const api = this.PlanningProjectsAPI.actions.importJobs;
    return this.callProjects(api, {ignoreNotValid: true}, filePreview, {projectId: projectId});
  }

  splitByPackages(projectId: string, draftId: string, draftJobId: string, request: {splits: [{packages: any[], resourceId?: number }]}) {
    const api = this.PlanningDraftsAPI.actions.splitJobByPackages;
    return this.callDrafts(api, {}, request, {projectId: projectId, draftId: draftId, draftJobId: draftJobId});
  }

  splitAndAssignJobByPackages(projectId: string, draftId: string, draftJobId: string, request: {splits: [{packages: any[], resourceId?: number, routeId?: number }]}, optimize: boolean) {
    const api = this.PlanningDraftsAPI.actions.splitAndAssignJobByPackages;
    return this.callDrafts(api, {optimize: optimize}, request, {projectId: projectId, draftId: draftId, draftJobId: draftJobId});
  }

  splitJobByLocation(projectId: string, draftId: string, draftJobId: string, request: {stops: {address: {locationId: string, locationType: string}}[]}) {
    const api = this.PlanningDraftsAPI.actions.splitJobByLocation;
    return this.callDrafts(api, {}, request, {projectId: projectId, draftId: draftId, draftJobId: draftJobId});
  }

  getJobSplitSuggestions(projectId: string, draftId: string, suggestionId: string) {
    const api = this.PlanningDraftsAPI.actions.getJobSplitSuggestions;
    return this.callDrafts(api, {}, {}, {projectId: projectId, draftId: draftId, suggestionId: suggestionId});
  }

  reverseJobSplit(projectId: string, draftId: string, splitSuggestionId: string) {
    const api = this.PlanningDraftsAPI.actions.reverseJobSplit;
    return this.callDrafts(api, {}, {}, {projectId: projectId, draftId: draftId, splitSuggestionId: splitSuggestionId});
  }

  generateJobSplitSuggestions(projectId: string, draftId: string) {
    const api = this.PlanningDraftsAPI.actions.generateJobSplitSuggestions;
    return this.callDrafts(api, {}, {}, {projectId: projectId, draftId: draftId});
  }

  bulkJobSplit(projectId: string, draftId: string, payload?: any) {
    const api = this.PlanningDraftsAPI.actions.bulkJobSplit;
    return this.callDrafts(api, {}, payload, {projectId: projectId, draftId: draftId});
  }

  generateRecommendations(projectId: string, draftId: string, recommendationConfigurationId: string) {
    const api = this.PlanningDraftsAPI.actions.generateRecommendations;
    return this.callDrafts(api, {recommendationConfigurationId: recommendationConfigurationId}, {}, {projectId: projectId, draftId: draftId});
  }

  private call(_apiCall, _params, _data, _options) {
    return this.$planning().$call(_apiCall, _params, _data, _options);
  }

  private callProjects(_apiCall, _params, _data, _options, id?) {
    return this.$planningProjects(id).$call(_apiCall, _params, _data, _options);
  }

  private callDrafts(_apiCall, _params, _data, _options, id?) {
    return this.$drafts(id).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.planning')
  .service('planningRequestsService', PlanningRequestsService);
